
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Impact() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/7f0293d7512ed50f0a6c6d3a5c6b9b63.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/80 to-blue-900/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Stories of <span className="text-yellow-300">Transformation</span>
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
              Every number represents a life changed, a family reunited, a future reclaimed. These are the stories that fuel our mission.
            </p>
          </div>
        </div>
      </section>

      {/* Impact Statistics */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Impact by the Numbers</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              18+ years of transforming lives through evidence-based, individualized support
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="text-center p-6 bg-emerald-50 rounded-xl">
              <div className="text-5xl font-bold text-emerald-600 mb-3">2,847</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Lives Transformed</h3>
              <p className="text-gray-600 text-sm">Individuals served since 2008</p>
            </div>
            
            <div className="text-center p-6 bg-blue-50 rounded-xl">
              <div className="text-5xl font-bold text-blue-600 mb-3">87%</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Housing Retention</h3>
              <p className="text-gray-600 text-sm">Maintain stable housing after 2 years</p>
            </div>
            
            <div className="text-center p-6 bg-purple-50 rounded-xl">
              <div className="text-5xl font-bold text-purple-600 mb-3">73%</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Employment Success</h3>
              <p className="text-gray-600 text-sm">Secure meaningful employment</p>
            </div>
            
            <div className="text-center p-6 bg-orange-50 rounded-xl">
              <div className="text-5xl font-bold text-orange-600 mb-3">92%</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Avoid Reincarceration</h3>
              <p className="text-gray-600 text-sm">Remain out of the justice system</p>
            </div>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="text-4xl font-bold text-gray-800 mb-3">1,234</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Families Reunited</h3>
              <p className="text-gray-600 text-sm">Children returned to stable homes</p>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="text-4xl font-bold text-gray-800 mb-3">18+</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Years of Service</h3>
              <p className="text-gray-600 text-sm">Continuous community support</p>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="text-4xl font-bold text-gray-800 mb-3">156</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Community Partners</h3>
              <p className="text-gray-600 text-sm">Organizations working together</p>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Real Stories, Real Impact</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Behind every statistic is a human story of resilience, growth, and transformation.
            </p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div 
                  className="w-16 h-16 rounded-full bg-cover bg-center flex-shrink-0"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20African%20American%20man%20in%20his%2040s%2C%20formerly%20incarcerated%20individual%20now%20successful%2C%20warm%20smile%20and%20professional%20attire%2C%20hope%20and%20redemption%20in%20expression%2C%20inspiring%20transformation%20story%2C%20natural%20lighting%20and%20authentic%20appearance&width=200&height=200&seq=story-marcus&orientation=squarish')`,
                    backgroundPosition: 'center top'
                  }}
                ></div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Marcus Johnson</h3>
                  <p className="text-emerald-600 font-medium">Program Graduate, Now Peer Counselor</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic mb-4 leading-relaxed">
                "When I walked out of prison after 8 years, I had nothing—no home, no job, no hope. IRN didn't just give me housing; they gave me back my dignity. Today, I'm not just housed—I'm home. I have a career helping others, and most importantly, I have my daughter back in my life."
              </blockquote>
              <div className="border-l-4 border-emerald-500 pl-4 bg-emerald-50 p-3 rounded">
                <p className="text-sm text-emerald-800 font-medium">Journey: 8 years incarcerated → Housed in 30 days → Employed in 6 months → Peer counselor in 2 years</p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div 
                  className="w-16 h-16 rounded-full bg-cover bg-center flex-shrink-0"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Portrait%20of%20resilient%20Latina%20woman%20in%20her%2030s%2C%20single%20mother%20overcoming%20homelessness%2C%20confident%20and%20hopeful%20expression%2C%20professional%20clothing%2C%20strength%20and%20determination%20in%20face%2C%20inspiring%20recovery%20story%2C%20warm%20natural%20lighting&width=200&height=200&seq=story-sofia&orientation=squarish')`,
                    backgroundPosition: 'center top'
                  }}
                ></div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Sofia Martinez</h3>
                  <p className="text-blue-600 font-medium">Single Mother, Small Business Owner</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic mb-4 leading-relaxed">
                "Living in my car with my two kids was the lowest point of my life. IRN's Housing First approach meant we had a safe place to sleep that very first night. Their employment program helped me start my catering business. Now my kids see their mom not as someone who struggled, but as someone who succeeded."
              </blockquote>
              <div className="border-l-4 border-blue-500 pl-4 bg-blue-50 p-3 rounded">
                <p className="text-sm text-blue-800 font-medium">Journey: Homeless with children → Housed immediately → Business training → Thriving catering business</p>
              </div>
            </div>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div 
                  className="w-16 h-16 rounded-full bg-cover bg-center flex-shrink-0"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Portrait%20of%20elderly%20white%20man%20in%20his%2060s%2C%20military%20veteran%20overcoming%20addiction%20and%20homelessness%2C%20dignified%20appearance%20with%20gray%20beard%2C%20wise%20and%20grateful%20expression%2C%20recovery%20success%20story%2C%20natural%20warm%20lighting&width=200&height=200&seq=story-robert&orientation=squarish')`,
                    backgroundPosition: 'center top'
                  }}
                ></div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Robert Thompson</h3>
                  <p className="text-purple-600 font-medium">Military Veteran, Recovery Advocate</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic mb-4 leading-relaxed">
                "Twenty years of addiction and homelessness stole my life from me. IRN's trauma-informed approach helped me understand that my addiction wasn't a moral failing—it was my way of coping with what I'd seen in war. They saved my life, and now I help save others."
              </blockquote>
              <div className="border-l-4 border-purple-500 pl-4 bg-purple-50 p-3 rounded">
                <p className="text-sm text-purple-800 font-medium">Journey: 20 years homelessness → Trauma therapy → 3 years sober → Leading veteran support groups</p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div 
                  className="w-16 h-16 rounded-full bg-cover bg-center flex-shrink-0"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Asian%20American%20woman%20in%20her%2020s%2C%20formerly%20homeless%20youth%20now%20college%20graduate%2C%20bright%20smile%20and%20graduation%20cap%2C%20hope%20and%20achievement%20in%20expression%2C%20educational%20success%20story%2C%20professional%20photography&width=200&height=200&seq=story-jenny&orientation=squarish')`,
                    backgroundPosition: 'center top'
                  }}
                ></div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Jenny Chen</h3>
                  <p className="text-orange-600 font-medium">College Graduate, Youth Advocate</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic mb-4 leading-relaxed">
                "I aged out of foster care at 18 with nowhere to go. IRN's youth program gave me more than housing—they gave me family. Their educational support helped me graduate college. Now I work with other foster youth, showing them that their past doesn't define their future."
              </blockquote>
              <div className="border-l-4 border-orange-500 pl-4 bg-orange-50 p-3 rounded">
                <p className="text-sm text-orange-800 font-medium">Journey: Foster care → Homeless at 18 → College scholarship → Youth program coordinator</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program Outcomes */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Long-Term Outcomes</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our success is measured not just in immediate placements, but in sustained positive outcomes over time.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Housing Stability</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-emerald-50 rounded-lg">
                  <span className="font-medium text-gray-900">6 months retention</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-emerald-600 h-3 rounded-full" style={{width: '94%'}}></div>
                    </div>
                    <span className="font-bold text-emerald-600">94%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-emerald-50 rounded-lg">
                  <span className="font-medium text-gray-900">1 year retention</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-emerald-600 h-3 rounded-full" style={{width: '91%'}}></div>
                    </div>
                    <span className="font-bold text-emerald-600">91%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-emerald-50 rounded-lg">
                  <span className="font-medium text-gray-900">2+ year retention</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-emerald-600 h-3 rounded-full" style={{width: '87%'}}></div>
                    </div>
                    <span className="font-bold text-emerald-600">87%</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Employment Success</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                  <span className="font-medium text-gray-900">Job placement</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-blue-600 h-3 rounded-full" style={{width: '81%'}}></div>
                    </div>
                    <span className="font-bold text-blue-600">81%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                  <span className="font-medium text-gray-900">6 month retention</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-blue-600 h-3 rounded-full" style={{width: '73%'}}></div>
                    </div>
                    <span className="font-bold text-blue-600">73%</span>
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                  <span className="font-medium text-gray-900">Career advancement</span>
                  <div className="flex items-center">
                    <div className="w-32 bg-gray-200 rounded-full h-3 mr-3">
                      <div className="bg-blue-600 h-3 rounded-full" style={{width: '58%'}}></div>
                    </div>
                    <span className="font-bold text-blue-600">58%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Impact */}
      <section 
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Thriving%20diverse%20community%20neighborhood%20with%20families%20and%20individuals%20of%20all%20backgrounds%20walking%20safely%20on%20clean%20streets%2C%20children%20playing%20in%20parks%2C%20community%20garden%20with%20tree%20of%20life%20centerpiece%2C%20warm%20sunset%20lighting%2C%20transformation%20of%20neighborhood%20through%20social%20programs%2C%20hope%20and%20community%20healing&width=1920&height=800&seq=community-impact&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/80 to-blue-900/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-6">Community-Wide Impact</h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Our work creates ripple effects that strengthen entire communities and break generational cycles.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-yellow-300 mb-3">$12.4M</div>
              <h3 className="text-xl font-semibold text-white mb-3">Economic Impact</h3>
              <p className="text-blue-100 text-sm">Annual economic benefit to the community through reduced incarceration and emergency services</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-yellow-300 mb-3">67%</div>
              <h3 className="text-xl font-semibold text-white mb-3">Crime Reduction</h3>
              <p className="text-blue-100 text-sm">Decrease in property crime in neighborhoods with high IRN participation</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-yellow-300 mb-3">1,847</div>
              <h3 className="text-xl font-semibold text-white mb-3">Children Stabilized</h3>
              <p className="text-blue-100 text-sm">Children who remained in or returned to stable homes with their parents</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Be Part of the Next Success Story</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Whether you need support or want to support others, join us in continuing to transform lives and strengthen communities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="primary" size="lg">
              <i className="ri-heart-line mr-2"></i>
              Get Involved
            </Button>
            <Button variant="outline" size="lg">
              <i className="ri-share-line mr-2"></i>
              Share Our Story
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
